import { TFunction } from 'i18next'

// Salto Space rejects an Expiration Date earlier than the user's original access activation
// date with the internal message "Start date/time bigger than end date/time" — reword it
// around the field the resident's activation date actually came from. Mirrors the same
// leaseStart-then-moveInDate fallback as SaltoSpaceService.createSaltoUserBaseData on the
// backend, so the named field matches what Salto actually used.
export const SALTO_INVALID_DATE_ORDER_MESSAGE = 'Start date/time bigger than end date/time'

export const getExpirationDateTooEarlyMessage = (
  leaseStart: number | null,
  moveInDate: number | null,
  t: TFunction<['clients']>,
) => {
  let fieldLabel: string = t(
    'clients:keylessAccess.saltoSpace.expirationDateTooEarly.activationDateFallback',
  )
  if (leaseStart) {
    fieldLabel = t('clients:keylessAccess.saltoSpace.expirationDateTooEarly.leaseStartLabel')
  } else if (moveInDate) {
    fieldLabel = t('clients:keylessAccess.saltoSpace.expirationDateTooEarly.moveInDateLabel')
  }

  return t('clients:keylessAccess.saltoSpace.expirationDateTooEarly.message', { fieldLabel })
}
